import request from '@/utils/request'

// 获取家人所有关系
export function getFamilyRelationshipList() {
  return request({
    url: '/api/v1/relationship/list',
    baseURL: 'other',
    method: 'get',
    params: ''
  })
}

// 获取登录用户的群下所有群员
export function getUserInfosByAccountId() {
  return request({
    url: '/api/v2/group/userinfos',
    baseURL: 'other',
    method: 'get',
    params: ''
  })
}

// 创建群组，并添加当前用户
export function createUserGroup(data) {
  return request({
    url: `/api/v1/group/userinfo?mac=${data.mac}&accountId=${data.accountId}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 为指定群组添加用户,v2版本家人关系
export function bindGroupFamily(data) {
  return request({
    url: `/api/v2/group/bind?userGroupId=${data.userGroupId}&phone=${data.phone}&relationShip=${data.relationShip}`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 家人好友申请
export function userGroupRequestInvite(data) {
  return request({
    url: `/api/v1/group/invite?accountId=${data.accountId}&phone=${data.phone}&relationShip=${data.relationShip}`,
    baseURL: 'other',
    method: 'get',
    data
  })
}

// 在指定群下注册用户
export function addGroupFamily(data) {
  return request({
    url: `/api/v1/group/userinfo/register`,
    baseURL: 'other',
    method: 'post',
    data
  })
}

// 解除群与用户绑定关系
export function minusGroupFamily(query) {
  return request({
    url: `/api/v1/group/remove`,
    baseURL: 'other',
    method: 'delete',
    params: query
  })
}

// 编辑家人信息及关系
export function EditGroupFamily(data) {
  return request({
    url: `/api/v1/group/uerinfo`,
    baseURL: 'other',
    method: 'put',
    data
  })
}

// 查询指定用户未处理好友申请数量
export function getRequestUnhandleCnt() {
  return request({
    url: '/api/v1/group/invite/cnt',
    baseURL: 'other',
    method: 'get',
    params: ''
  })
}

// 查询指定用户好友申请列表
export function getUserGroupRequestUserList(data) {
  return request({
    url: '/api/v1/group/request/info/list',
    baseURL: 'other',
    method: 'get',
    params: data
  })
}

// 同意好友申请
export function userGroupRequestAgree(data) {
  return request({
    url: '/api/v1/group/agree',
    baseURL: 'other',
    method: 'get',
    params: data
  })
}
// 拒绝好友申请
export function userGroupRequestRefuse(data) {
  return request({
    url: '/api/v1/group/refuse',
    baseURL: 'other',
    method: 'get',
    params: data
  })
}

// 删除申请操作记录
export function delUserGroupRequest(data) {
  return request({
    url: `/api/v1/group/request`,
    baseURL: 'other',
    method: 'delete',
    params: data
  })
}
// 查询指定好友申请详情"
export function getUserGroupRequestUser(data) {
  return request({
    url: '/api/v1/group/request/info',
    baseURL: 'other',
    method: 'get',
    params: data
  })
}
